// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are redirected to the login page.
import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { getToken, logout } from '../../services/User';

const PrivateRoute = ({ component: Component, ...rest }) => {

  // Add your own authentication on the below line.
  function checkLogin(){
    
    const xToken = getToken();
    
    if (!xToken) {
    return false;
    }
    return true;
  }
  const isLoggedIn = checkLogin();
  
  const originalUrl = document.location.pathname;
  
  return (
    <Route
      {...rest}
      render={props =>
        isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: `/signin/?originalUrl=${originalUrl}` }}  />
          
        )
      }
    />
  )
}

export default PrivateRoute